import React from 'react'
import './button.scss'


const Resume = () => {
    return (
        <div>
            <a href="resume-suman.pdf" download="Suman_Resume.pdf"><button className="Down">Download Resume</button></a>
        </div>
    )
}

export default Resume
